Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    expanderMobileSpacingInset: 16,
    expanderMobileTitleHeight: 48,
    expanderMobileTitleFontSize: 16,
    expanderMobileTitleBackgroundColorPressed: tokens.themeBackgroundOverlayPressed,
    expanderMobileTitleBackgroundOpacityPressed: 16,
    expanderMobileValueFontSize: 14,
    expanderMobileForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
    expanderMobileForegroundColorDefaultDisabled: tokens.themeBorderSecondaryDefault,
    expanderMobileForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
    expanderMobileForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
    expanderMobileForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
    expanderSpacingVertical: 10,
    expanderSpacingHorizontal: 20,
    expanderForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
    expanderForegroundColorDefaultHover: tokens.themeForegroundAccentHover,
    expanderForegroundColorDefaultPressed: tokens.themeForegroundAccentPressed,
    expanderForegroundColorDefaultDisabled: tokens.themeBorderAccentDisabled,
    expanderForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
    expanderForegroundColorInlineHover: tokens.themeForegroundAccentHover,
    expanderForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
    expanderForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
    expanderBackgroundColorBox: tokens.themeBackgroundPrimaryDefault,
    expanderBorderWidth: 1,
    expanderBorderColor: tokens.themeBorderSecondaryDefault,
    expanderBorderRadius: 0,
    expanderBorderRadiusBox: 4,
    expanderMotionDelay: "100ms",
    expanderMotionDuration: "200ms",
    expanderMotionIconFunction: "ease",
    expanderMotionChildContentFunction: "ease"
  }
};